export default __webpack_public_path__ + "static/media/mood_shock_off.2832c708.svg";